import React from 'react'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import axios from 'axios'
export default function VehicleOverview() {
    const [vehicledata, setVehicleData] = React.useState([])
    const [ownerdata, setOwnerData] = React.useState([])
    const [registrationdata, setRegistrationData] = React.useState([])
    const [permitdata, setPermitData] = React.useState([])
    const [isToggled, setIsToggled] = useState(true);
    const handleChange = () => {
      setIsToggled(!isToggled);
      setIsToggled2(false);
      setIsToggled3(false);
      setIsToggled4(false);
    };
    const [isToggled2, setIsToggled2] = useState(false);
    const handleChange2 = () => {
      setIsToggled2(!isToggled2);
      setIsToggled3(false);
      setIsToggled4(false);
      setIsToggled(false);
    };
    const [isToggled3, setIsToggled3] = useState(false);
    const handleChange3 = () => {
      setIsToggled3(!isToggled3);
      setIsToggled2(false);
      setIsToggled4(false);
      
      setIsToggled(false);
    };
    const [isToggled4, setIsToggled4] = useState(false);
    const handleChange4 = () => {
      setIsToggled4(!isToggled4);
      setIsToggled2(false);
      setIsToggled3(false);
      
      setIsToggled(false);
    };
    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL+'/api/vehicles/getvehicles')
        .then((response) => {
            setVehicleData(response.data)
        }
        )
        axios.get(process.env.REACT_APP_API_URL+'/api/owner/owners')
        .then((response) => {
            setOwnerData(response.data)
        }
        )
        axios.get(process.env.REACT_APP_API_URL+'/api/registration/getregistrations')
        .then((response) => {
            setRegistrationData(response.data)
        }
        )
        axios.get(process.env.REACT_APP_API_URL+'/api/permit/getpermits')
        .then((response) => {
            setPermitData(response.data)
        }
        )
    }, [])

  return (
    
   <>
    {/* Complete Overview of Individual vehicle including the registration permit owner detials insurance */}
    <div className="h-10 m-0 p-0 bg-slate-500 opacity-30" style={{borderRadius:'4px'}}>
      <input type="text" className=" m-2" style={{borderRadius: '4px'}} placeholder="Search"/>
    </div>
    <div>
        <section className="mx-auto w-full max-w-7xl"> 
            <div className=" space-y-4 md:flex-row md:items-center  md:space-y-0 p-1">
                <div>
                    <h1 className="text-lg font-semibold" align="center">Vehicle Overview</h1>
                </div>
                <div className=''>
                </div>

            </div>
            <div className='vehicaltabbed'>
                <div className='vehicaltabbuttons'>
                <button onClick={handleChange} className={` ${isToggled ? 'tabbedbuttonactive' : 'tabbedbuttonoff'}`}>
                              Vehical Details
                </button>
                <button onClick={handleChange2} className={` ${isToggled2 ? 'tabbedbuttonactive' : 'tabbedbuttonoff'}`}>
                            Owner Details
                </button>
                <button onClick={handleChange3} className={` ${isToggled3 ? 'tabbedbuttonactive' : 'tabbedbuttonoff'}`}>
                             Registration Details
                </button>
                <button onClick={handleChange4} className={` ${isToggled4 ? 'tabbedbuttonactive' : 'tabbedbuttonoff'}`}>
                              Vehical Permit Details
                </button>
                </div>

                <div className={` ${isToggled ? 'tab-content1' : 'hidden'}`}>
                <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                        scope='col'
                                        className="px-2 py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            ID
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Vehicle Num
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Chasis No
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Engine No
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Manufacturer
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Maker Model
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Vehicle Class
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Fuel Type
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Color
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            is Active
                                        </th> 
                                        
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-gray-200">
                                    {/* <tr>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            1
                                        </td>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            AP16 KHV
                                        </td>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            123456789
                                        </td>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            987654321
                                        </td>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            BharatBenz
                                        </td>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            2823C
                                        </td>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            Truck
                                        </td>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            Diesel
                                        </td>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            Blue
                                        </td>
                                        <td className="py-4 whitespace-nowrap border text-center">
                                            <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                                                Active
                                            </span>
                                        </td>
                                    </tr> */}
                                     {vehicledata.map((vehicle) => (
                                        <tr key={vehicle.id}>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {vehicle.id}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-right p-1">
                                                {vehicle.vehiclenumber}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-right p-1">
                                                {vehicle.chassisnumber}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-right p-1">
                                                {vehicle.enginenumber}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-left p-1">
                                                {vehicle.manufacturer}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-left p-1">
                                                {vehicle.model}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-left p-1">
                                                {vehicle.vehicleclass}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-left p-1">
                                                {vehicle.fueltype}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-left p-1">
                                                {vehicle.color}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                                                    Active
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                </div>
                <div className={` ${isToggled2 ? 'tab-content2' : 'hidden'}`}>
                <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                        scope='col'
                                        className="px-2 py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            ID
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Name
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Ownership
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Owner Type
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Address
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Contact Number
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            is Active
                                        </th> 
                                        
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-gray-200">
                                    {/* owner details */}
                                    {ownerdata.map((owner) => (
                                        <tr key={owner.id}>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {owner.id}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {owner.ownername}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {owner.ownership}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {owner.ownertype}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {owner.address}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {owner.contact}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                                                    Active
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        
                </div>
                <div className={` ${isToggled3 ? 'tab-content3' : 'hidden'}`}>
                <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                        scope='col'
                                        className="px-2 py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            ID
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Registration Number
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Registration Date
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Registration RTO
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            RC Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-gray-200">
                                    {/* registration details */}
                                    {registrationdata.map((registration) => (
                                        <tr key={registration.id}>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {registration.id}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {registration.regnumber}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {registration.registrationdate}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {registration.registrationrto}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                                                    Active
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        
                </div>
                <div className={` ${isToggled4 ? 'tab-content4' : 'hidden'}`}>
                <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                        scope='col'
                                        className="px-2 py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            ID
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Permit Number
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Permit Holder Name
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Permit Holder Address
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Permit Vehicle Type
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Permit Valid From
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Permit Valid To
                                        </th>
                                        <th
                                        scope='col'
                                        className="py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                                            Permit Route
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-gray-200">
                                    {/* permit details */}
                                    {permitdata.map((permit) => (
                                        <tr key={permit.id}>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {permit.id}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {permit.permitnumber}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {permit.holdername}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {permit.address}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {permit.vehicletype}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {permit.permit_validity_from}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {permit.permit_validity_to}
                                            </td>
                                            <td className="py-4 whitespace-nowrap border text-center">
                                                {permit.permit_route}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                            </table>

                </div>
            </div>
                           
         
        </section>
    </div>
   </>
  )
}
